export default "__VITE_ASSET__DsQbqlb$__"